import React, { useState } from 'react';
import { services, bookings, serviceHistory, pets, users } from '../mock/servicesData';
import ServiceCard from '../components/ServiceCard';
import ServiceModal from '../components/ServiceModal';
import ServiceBookingModal from '../components/ServiceBookingModal';

const ServicesPage = () => {
  const [currentUser] = useState(users[0]);
  const [servicesList, setServicesList] = useState(services);
  const [showServiceModal, setShowServiceModal] = useState(false);
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [editingService, setEditingService] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
  const [activeTab, setActiveTab] = useState('catalog');

  const caregivers = users.filter(u => u.role === 'caregiver');
  const userPets = pets.filter(p => p.ownerId === currentUser.id);

  const handleSaveService = (service, isEdit) => {
    if (isEdit) {
      setServicesList(prev => prev.map(s => 
        s.id === editingService.id ? { ...service, id: editingService.id } : s
      ));
    } else {
      setServicesList(prev => [...prev, {
        ...service,
        id: `serv-${Date.now()}`
      }]);
    }
    setShowServiceModal(false);
    setEditingService(null);
  };

  const handleConfirmBooking = (booking) => {
    // En una app real, aquí se enviaría al backend
    console.log('Reserva confirmada:', booking);
  };

  return (
    <div className="ml-64 p-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Servicios</h2>
        
        <div className="flex items-center space-x-4">
          <div className="flex border border-gray-300 rounded-lg overflow-hidden">
            <button
              onClick={() => setActiveTab('catalog')}
              className={`px-4 py-2 ${activeTab === 'catalog' ? 'bg-cyan-600 text-white' : 'bg-white'}`}
            >
              Catálogo
            </button>
            <button
              onClick={() => setActiveTab('bookings')}
              className={`px-4 py-2 ${activeTab === 'bookings' ? 'bg-cyan-600 text-white' : 'bg-white'}`}
            >
              Mis Reservas
            </button>
          </div>

          {currentUser.role === 'admin' && (
            <button
              onClick={() => {
                setEditingService(null);
                setShowServiceModal(true);
              }}
              className="flex items-center px-4 py-2 bg-cyan-600 text-white rounded-lg hover:bg-cyan-700"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
              Nuevo Servicio
            </button>
          )}
        </div>
      </div>

      {activeTab === 'catalog' ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {servicesList.map(service => (
            <ServiceCard
              key={service.id}
              service={service}
              onEdit={setEditingService}
              onDelete={(id) => setServicesList(prev => prev.filter(s => s.id !== id))}
              onBook={() => {
                setSelectedService(service);
                setShowBookingModal(true);
              }}
              currentUser={currentUser}
            />
          ))}
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-sm p-6">
          <h3 className="text-lg font-semibold mb-4">Mis Reservas</h3>
          {bookings.filter(b => userPets.some(p => p.id === b.petId)).length > 0 ? (
            <div className="space-y-3">
              {bookings
                .filter(b => userPets.some(p => p.id === b.petId))
                .map(booking => (
                  <div key={booking.id} className="bg-gray-50 p-4 rounded-lg">
                    <div className="flex justify-between">
                      <div>
                        <h4 className="font-medium">
                          {services.find(s => s.id === booking.serviceId)?.name}
                        </h4>
                        <p className="text-sm text-gray-600">
                          {pets.find(p => p.id === booking.petId)?.name} - {booking.date} {booking.time}
                        </p>
                      </div>
                      <span className="bg-cyan-100 text-cyan-800 px-3 py-1 rounded-full text-sm">
                        {booking.status}
                      </span>
                    </div>
                  </div>
                ))}
            </div>
          ) : (
            <div className="text-center py-8">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6-2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <p className="text-gray-500 mt-2">No tienes reservas activas</p>
            </div>
          )}
        </div>
      )}

      {showServiceModal && (
        <ServiceModal
          onClose={() => {
            setShowServiceModal(false);
            setEditingService(null);
          }}
          onSave={handleSaveService}
          serviceToEdit={editingService}
        />
      )}

      {showBookingModal && selectedService && (
        <ServiceBookingModal
          service={selectedService}
          pets={userPets}
          caregivers={caregivers}
          onClose={() => setShowBookingModal(false)}
          onConfirm={handleConfirmBooking}
        />
      )}
    </div>
  );
};

export default ServicesPage;